"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserLinkDisplayComponent = exports.UserTextDisplayComponent = exports.getUserUrlForDisplay = exports.getUserNameForDisplay = exports.isUserActive = exports.isUserInfoVisible = exports.UserNameText = exports.DefaultHiddenUserElement = exports.DefaultNoneUserElement = exports.UserPlaceholderStyle = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_messages_1 = require("@tableau/catalog-messages");
/** This matches the HiddenUserStyle in VizPortalClient */
exports.UserPlaceholderStyle = {
    color: '#BFBFBF',
    fontWeight: 'inherit',
};
function DefaultNoneUserElement() {
    return react_1.default.createElement("span", { style: exports.UserPlaceholderStyle }, catalog_messages_1.Messages.None());
}
exports.DefaultNoneUserElement = DefaultNoneUserElement;
function DefaultHiddenUserElement() {
    return react_1.default.createElement("span", { style: exports.UserPlaceholderStyle }, catalog_messages_1.Messages.HiddenUser());
}
exports.DefaultHiddenUserElement = DefaultHiddenUserElement;
function UserNameText(props) {
    return react_1.default.createElement("span", null, props.name);
}
exports.UserNameText = UserNameText;
function isUserInfoVisible(user) {
    // Some fields may still possibly be empty string, which is still "visible"
    return user.domain !== null || user.name !== null || user.username !== null;
}
exports.isUserInfoVisible = isUserInfoVisible;
function isUserActive(user) {
    return user.domain !== null && user.username !== null;
}
exports.isUserActive = isUserActive;
function getUserNameForDisplay(user) {
    // The name should always be defined for these types, but the previous
    // code fell back to username so we're preserving that logic here, just in case
    // some client code doesn't have strict null checks.
    return user.name || user.username || '';
}
exports.getUserNameForDisplay = getUserNameForDisplay;
function getUserUrlForDisplay(urls, user) {
    return urls.userUrl(user.username, user.domain);
}
exports.getUserUrlForDisplay = getUserUrlForDisplay;
function getUserPathForDisplay(urls, user) {
    return urls.userPath(user.username, user.domain);
}
function UserTextDisplayComponent(props) {
    if (!props.user) {
        return props.noneUserElement || react_1.default.createElement(DefaultNoneUserElement, null);
    }
    else if (!isUserInfoVisible(props.user)) {
        return props.hiddenUserElement || react_1.default.createElement(DefaultHiddenUserElement, null);
    }
    else {
        const name = getUserNameForDisplay(props.user);
        return react_1.default.createElement(UserNameText, { name: name });
    }
}
exports.UserTextDisplayComponent = UserTextDisplayComponent;
function UserLinkDisplayComponent(_a) {
    var { user } = _a, props = tslib_1.__rest(_a, ["user"]);
    const urls = (0, catalog_core_1.useSiteUrls)();
    if (!user) {
        return props.noneUserElement || react_1.default.createElement(DefaultNoneUserElement, null);
    }
    else if (!isUserInfoVisible(user)) {
        return props.hiddenUserElement || react_1.default.createElement(DefaultHiddenUserElement, null);
    }
    else if (!isUserActive(user)) {
        return react_1.default.createElement(UserNameText, { name: user.name });
    }
    else {
        const name = getUserNameForDisplay(user);
        const url = getUserUrlForDisplay(urls, user);
        const path = getUserPathForDisplay(urls, user);
        return react_1.default.createElement(props.linkComponent, { name: name, url: url, pathname: path });
    }
}
exports.UserLinkDisplayComponent = UserLinkDisplayComponent;
//# sourceMappingURL=UserDisplayComponent.js.map